"use client";

import { onCLS, onINP, onLCP, onFCP, onTTFB } from "web-vitals";
import { sendTelemetry } from "./telemetry-client";
import { getTelemetryContext } from "./telemetry-context";

declare global {
  interface Window {
    __csdeskVitalsRegisteredForRoute?: string;
  }
}

export function registerWebVitals() {
  if (typeof window === "undefined") return () => {};

  const ctx = getTelemetryContext();
  if (!ctx.pageKey || !ctx.route) return () => {};

  const routeKey = `${ctx.pageKey}::${ctx.route}`;

  // Evita duplicar em dev (StrictMode / Fast Refresh)
  if (window.__csdeskVitalsRegisteredForRoute === routeKey) return () => {};
  window.__csdeskVitalsRegisteredForRoute = routeKey;

  const metrics: Record<string, number> = {};

  const unsub: Array<() => void> = [];
  onLCP((m) => (metrics.lcp = m.value));
  unsub.push(() => {});
  onINP((m) => (metrics.inp = m.value));
  unsub.push(() => {});
  onCLS((m) => (metrics.cls = m.value));
  unsub.push(() => {});
  onFCP((m) => (metrics.fcp = m.value));
  unsub.push(() => {});
  onTTFB((m) => (metrics.ttfb = m.value));
  unsub.push(() => {});

  const timer = setTimeout(() => {
    const cur = getTelemetryContext();
    if (!cur.pageKey || !cur.route) return;

    // garante que envia com o contexto atual
    sendTelemetry({
      schemaVersion: 1,
      type: "rum",
      pageKey: cur.pageKey,
      route: cur.route,
      sampleRate: cur.sampleRate,
      metrics,
    });
  }, 4000);

  return () => {
    clearTimeout(timer);
    for (const fn of unsub) fn();
    // libera para re-registrar ao trocar rota
    if (window.__csdeskVitalsRegisteredForRoute === routeKey) {
      window.__csdeskVitalsRegisteredForRoute = undefined;
    }
  };
}
